(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main__secondSlider"] && !Shopify.designMode) return;
  try {
    
$('.single-item').slick();
$('.variable-width').slick({
  dots: true,
  infinite: true,
  speed: 800,
  swipeToSlide: true,
  touchMove: true,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 7000,
  variableWidth: true,

});


  } catch(e) { console.error(e); }
})();
})();
